<template>
  <div>
    <div style='margin-right: 10px'>
      <el-tooltip content="点击打开【我的菜单】-查看完整的菜单" placement="left-end" effect="light">
        <el-button @click='goToPage' circle icon='el-icon-menu' size='medium' title='我的菜单'></el-button>
      </el-tooltip>
      <!--      <el-popover-->
      <!--        placement="left-start"-->
      <!--        title="系统菜单"-->
      <!--        width="200"-->
      <!--        trigger="hover"-->
      <!--        content="点击打开【我的菜单】-查看完整的菜单">-->
      <!--        <el-button slot="reference" @click='goToPage' circle icon='el-icon-menu' size='medium' title='展开所有菜单'></el-button>-->
      <!--      </el-popover>-->

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      drawer: false
    }
  },
  computed: {
    ...mapGetters(['routePath', 'userPermissions', 'isCollapse'])

  },
  props: {
    isNavOverflow: {
      type: Boolean
    }
    ,
    navMenus: {
      type: Array,
      required: true
    }
  }
  ,
  methods: {
    goToPage() {
      //判断是否当前页面
      // console.log(this.$route.name)
      if (this.$route.name !== 'myNav')
        this.$router.push({ name: 'myNav' })
    }

  }
}
</script>

<style scoped>

</style>
